import Logo from "./../media/logo.png";
import { Link, useLocation } from "react-router-dom";
import { useHistory } from "react-router-dom";
import { useState } from "react";
import axios from "axios";
import { FaChevronRight, FaChevronLeft, FaPowerOff, FaChevronDown } from "react-icons/fa";

const NAV_ITEMS = [
  { label: "Inicio", path: "/dashboard", exact: true },
  {
    label: "Órdenes",
    children: [
      { label: "Cotizaciones", path: "/dashboard/cotizaciones" },
      { label: "Seguimiento",  path: "/dashboard/seguimiento" },
      { label: "Entregadas",   path: "/dashboard/entregadas" },
    ],
  },
  {
    label: "Clientes",
    children: [
      { label: "Cuentas",     path: "/dashboard/crm", activeWhen: (p) => p === "/dashboard/crm" || p.startsWith("/dashboard/crm/cuenta") },
      { label: "Prospección", path: "/dashboard/crm/prospeccion" },
      { label: "Tareas",      path: "/dashboard/crm/tareas" },
    ],
  },
  {
    label: "Administración",
    children: [
      { label: "Sistema",    path: "/dashboard/admin", adminOnly: true },
      { label: "Procesos",   path: "/dashboard/procesos" },
      { label: "Comisiones", path: "/dashboard/comisiones" },
    ],
  },
];

// ¿El usuario logueado es administrador? (tipo === 1)
const getIsAdmin = () => {
  try { return String(JSON.parse(localStorage.getItem("user") || "{}").tipo) === "1"; }
  catch { return false; }
};

const DRAWER_W = 240;

const matchItem = (item, pathname) => {
  if (item.activeWhen) return item.activeWhen(pathname);
  if (item.exact)      return pathname === item.path;
  return pathname === item.path || pathname.startsWith(item.path + "/");
};

const Header = () => {
  const [open, setOpen] = useState(false);
  const [openGroup, setOpenGroup] = useState(null); // label del grupo abierto manualmente
  const location = useLocation();
  const history  = useHistory();
  const isAdmin  = getIsAdmin();

  // Nav filtrada según rol: los no-admin no ven el panel "Sistema"
  const navItems = NAV_ITEMS.map((it) =>
    it.children ? { ...it, children: it.children.filter((c) => !c.adminOnly || isAdmin) } : it
  );

  // Grupo que contiene la ruta activa (para auto-expandir)
  const activeGroupLabel = navItems.find(
    (it) => it.children && it.children.some((c) => matchItem(c, location.pathname))
  )?.label ?? null;

  const isActive = (item) => matchItem(item, location.pathname);

  const close = () => setOpen(false);

  const logOut = () => {
    if (window.confirm("¿Estás seguro de que deseas cerrar sesión?")) {
      axios
        .get(`${process.env.REACT_APP_API_BASE||"http://localhost/twinpack/php"}/logout.php`)
        .then(() => history.push("/"))
        .catch(() => alert("Hubo un error al cerrar sesión. Intenta de nuevo."));
    }
  };

  return (
    <>
      {/* ── Pestaña lateral (visible solo cuando el drawer está cerrado) ── */}
      {!open && (
        <button
          onClick={() => setOpen(true)}
          title="Abrir menú"
          style={{
            position: "fixed",
            left: 0,
            top: "50%",
            transform: "translateY(-50%)",
            width: 22,
            height: 64,
            background: "#9f0059",
            border: "none",
            borderRadius: "0 10px 10px 0",
            cursor: "pointer",
            zIndex: 300,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            boxShadow: "2px 2px 10px rgba(0,0,0,0.25)",
            padding: 0,
          }}
        >
          <FaChevronRight size={11} color="white" />
        </button>
      )}

      {/* ── Backdrop ── */}
      {open && (
        <div
          onClick={close}
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(0,0,0,0.35)",
            zIndex: 200,
            backdropFilter: "blur(1px)",
          }}
        />
      )}

      {/* ── Drawer ── */}
      <aside
        style={{
          position: "fixed",
          top: 0,
          left: open ? 0 : -DRAWER_W - 10,
          width: DRAWER_W,
          height: "100vh",
          background: "#121212",
          zIndex: 250,
          display: "flex",
          flexDirection: "column",
          transition: "left 0.28s cubic-bezier(.4,0,.2,1)",
          boxShadow: open ? "4px 0 20px rgba(0,0,0,0.4)" : "none",
        }}
      >
        {/* Logo + botón cerrar */}
        <div style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          borderBottom: "1px solid #222",
          padding: "0 12px 0 0",
          flexShrink: 0,
        }}>
          <img
            src={Logo}
            alt="Twin Pack"
            style={{
              width: "100%",
              padding: "12px 20px",
              objectFit: "contain",
            }}
          />
          <button
            onClick={close}
            title="Cerrar menú"
            style={{
              background: "none",
              border: "none",
              color: "#777",
              cursor: "pointer",
              padding: "8px",
              display: "flex",
              alignItems: "center",
              borderRadius: 6,
            }}
          >
            <FaChevronLeft size={15} />
          </button>
        </div>

        {/* Items de navegación */}
        <nav style={{ flex: 1, overflowY: "auto", paddingTop: 10, paddingBottom: 10 }}>
          {navItems.map((item) => {
            // ── Ítem simple (sin hijos) ──
            if (!item.children) {
              const active = isActive(item);
              return (
                <Link
                  key={item.path}
                  to={item.path}
                  onClick={close}
                  style={{
                    display: "block",
                    padding: "13px 24px",
                    color: active ? "#fff" : "#aaa",
                    background: active ? "rgba(159,0,89,0.2)" : "transparent",
                    borderLeft: active ? "3px solid #9f0059" : "3px solid transparent",
                    textDecoration: "none",
                    fontSize: 15,
                    fontWeight: active ? 600 : 400,
                    letterSpacing: "0.01em",
                    transition: "background 0.15s, color 0.15s",
                    whiteSpace: "nowrap",
                  }}
                >
                  {item.label}
                </Link>
              );
            }

            // ── Grupo con hijos (acordeón) ──
            const groupActive = item.children.some((c) => isActive(c));
            const expanded = openGroup !== null ? openGroup === item.label : activeGroupLabel === item.label;
            return (
              <div key={item.label}>
                <button
                  onClick={() => setOpenGroup(expanded ? "__none__" : item.label)}
                  style={{
                    width: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    padding: "13px 24px",
                    color: groupActive ? "#fff" : "#aaa",
                    background: "transparent",
                    border: "none",
                    borderLeft: groupActive ? "3px solid #9f0059" : "3px solid transparent",
                    cursor: "pointer",
                    fontSize: 15,
                    fontWeight: groupActive ? 600 : 400,
                    letterSpacing: "0.01em",
                    whiteSpace: "nowrap",
                    fontFamily: "inherit",
                  }}
                >
                  <span>{item.label}</span>
                  <FaChevronDown
                    size={11}
                    style={{ transform: expanded ? "rotate(180deg)" : "none", transition: "transform 0.2s", opacity: 0.7 }}
                  />
                </button>
                {expanded && item.children.map((c) => {
                  const active = isActive(c);
                  return (
                    <Link
                      key={c.path}
                      to={c.path}
                      onClick={close}
                      style={{
                        display: "block",
                        padding: "10px 24px 10px 40px",
                        color: active ? "#fff" : "#999",
                        background: active ? "rgba(159,0,89,0.22)" : "rgba(255,255,255,0.02)",
                        borderLeft: active ? "3px solid #9f0059" : "3px solid transparent",
                        textDecoration: "none",
                        fontSize: 14,
                        fontWeight: active ? 600 : 400,
                        whiteSpace: "nowrap",
                        transition: "background 0.15s, color 0.15s",
                      }}
                    >
                      {c.label}
                    </Link>
                  );
                })}
              </div>
            );
          })}
        </nav>

        {/* Cerrar sesión */}
        <div style={{
          borderTop: "1px solid #222",
          padding: "14px 20px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          flexShrink: 0,
        }}>
          <span style={{ color: "#555", fontSize: 12 }}>Sesión activa</span>
          <button
            onClick={logOut}
            title="Cerrar sesión"
            style={{
              background: "none",
              border: "none",
              color: "#888",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              gap: 8,
              fontSize: 13,
              padding: "6px 8px",
              borderRadius: 6,
              transition: "color 0.2s",
            }}
          >
            <FaPowerOff size={13} />
            <span>Salir</span>
          </button>
        </div>
      </aside>
    </>
  );
};

export default Header;
